import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import Select from "react-select";

const Trial_balance = () => {
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());

    const [typeOptionTrail, setTypeOptionTrail] = useState('L');
    const [groupFilterTrail, setSelectOption] = useState('A');

    const [counter, setCounter] = useState(0);

    const [radioType, setRadioType] = useState('A');

    const [checkItem, setCheckItem] = useState(true);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [groupValueTrail, setGroupValueTrail] = useState(null);
    const [groupCode, setGroupCode] = useState('');
    const [individualGroup, setIndividualGroup] = useState([]);
    const [showGroupDD, setShowGroupDD] = useState(false);

    const [ledgerValueTrail, setLedgerValueTrail] = useState(null);
    const [grpCode, setGrpCode] = useState('');
    const [accountCode, setAccountCode] = useState('');
    const [individualLedger, setIndividualLedger] = useState([]);
    const [trialMode, settrialMode] = useState("V");
    const [scr, setScr] = useState("");
    const [trialList, settrialList] = useState([]);
    const [locationTypeTrail, setLocationTypeTrail] = useState("A");
    const [locationCode, setLocationCode] = useState(0);
    const [trailLocation, setTrailLocation] = useState(null);

    const [vgParentGrpList, setVgParentGrpList] = useState([]);
    const [srchParentGrp, setSrchParentGrp] = useState({ value: 0, label: "All" });
    const [onceRun, setOnceRun] = useState(false);
    const [filterConsolAllOne, setFilterConsolAllOne] = useState('C');

    var msg = [], i = 0;

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setTrailLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRIAL_BALANCE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    Common.callApi(Common.apiVoucher, [sid, "allgroupjson"], result => {
                        setVgParentGrpList(JSON.parse(result));
                    });
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);
    const handleChangeLocation = (value) => {
        setTrailLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }
    const handleTypeChange = (e) => {
        const value = e.target.value;
        setTypeOptionTrail(value);
        setShowGroupDD(false);
        setSelectOption('0');
    }

    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSelectOption(value);
        if (typeOptionTrail == 'G' && value == 'O') {
            setShowGroupDD(true);
        } else if (typeOptionTrail == 'L' && value == 'O') {
            setShowGroupDD(false);
        } else {
            setShowGroupDD(false);
            // setShowLedgerDD(false);
        }
    }

    const handleGroupValue = (value) => {
        setGroupValueTrail(value);
        console.log(value);

        var grp = value.id.split('^');
        setGroupCode(grp[1]);

        if (typeOptionTrail == 'G' && groupFilterTrail == 'O') {
            setIndividualGroup(grp[1]);
            setIndividualLedger([]);
            setLedgerValueTrail('');

            // setCount(count+1);
        }
    }

    const checkBoxHandler = (e) => {
        let checked = e.target.checked;
        let value = e.target.value;
        setCheckItem(checked);
    }

    const handleGenerate = () => {

        $(".loader").show();

        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgText("Date should be within financial year");
            setMsgBox(true);
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        if (fromDate == null || toDate == null || (typeOptionTrail == 'G' && groupFilterTrail == 'O' && groupValueTrail == null) ||
            (typeOptionTrail == 'L' && groupFilterTrail == 'O' && ledgerValueTrail == null)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (fromDate == null ? "Please select from date." : '');
            msg[i++] = (toDate == null ? "Please select to date." : '');
            msg[i++] = ((typeOptionTrail == 'G' && groupFilterTrail == 'O' && groupValueTrail == null) ? "Please select group." : '');

            $(".loader").hide();

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            const obj = {
                locationType: locationTypeTrail,
                location: locationCode,
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                typeGroupLedger: typeOptionTrail,
                groupFilter: groupFilterTrail,
                radioType: radioType,
                checkItem: checkItem,
                group: groupCode,
                showHeader: true,
                parentGroupCode: srchParentGrp.value,
                filterConsolAllOne: filterConsolAllOne
            }
            console.log(obj);
            if (trialMode === 'D') {
                Common.callDownloadApiPost1(Common.apiTrialBalance, "post", [sid, "download", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apiTrialBalance, [sid, "viewdata", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                {scr === "" ?
                    <>
                        <Row>
                            <Col>
                                <h2>Trial Balance<span style={{ color: "#f8f9fd" }}>{counter}</span> </h2>
                            </Col>
                        </Row>&nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={trialMode} onChange={e => settrialMode(e.target.value)}
                                        required>
                                        <option value="V">View</option>
                                        <option value="D">Download</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={locationTypeTrail} onChange={e => setLocationTypeTrail(e.target.value)}
                                        required>
                                        <option value="A">All</option>
                                        <option value="O">One</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {/* <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select value={filterConsolAllOne} onChange={e => setFilterConsolAllOne(e.target.value)}
                                        required>
                                        <option value="C">Consolidated</option>
                                        <option value="L">LocationWise</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}
                            {locationTypeTrail === 'O' ? <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={trailLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col></> : null}
                        </Row>&nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Group</Form.Label>
                                    <Select options={vgParentGrpList} value={srchParentGrp} onChange={v => setSrchParentGrp(v)} />
                                </Form.Group>
                            </Col>
                        </Row>&nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={fromDate}
                                        onChange={(date) => setFromDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                    <DatePicker className="form-control"
                                        selected={toDate}
                                        onChange={(date) => setToDate(date)}
                                        dateFormat="dd/MM/yyyy"
                                        showYearDropdown
                                        showMonthDropdown
                                        useShortMonthInDropdown
                                        dropdownMode="select"
                                        peekNextMonth
                                        customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {
                                /*
                                    <Col className='col-md-3 col-6'>
                                        <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label><br />
                                        <select class="form-select" aria-label="Default select example" value={typeOptionTrail}
                                            onChange={(e) => handleTypeChange(e)} >
                                            <option value="L">Ledger</option>
                                            <option value="G">Group</option>
                                        </select>
                                    </Col>
                                */
                            }
                            <Col></Col>

                        </Row>

                        <Row>
                            {typeOptionTrail == 'G' ?
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Group Filter<span className="colorThemeRed">*</span></Form.Label><br />
                                    <select class="form-select" aria-label="Default select example" value={groupFilterTrail}
                                        onChange={(e) => handleSelectChange(e)}>
                                        <option value="A" >All</option>
                                        <option value="O">One</option>
                                    </select>
                                </Col>
                                : null}

                            {
                                groupFilterTrail === 'O' &&
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Group<span className="colorThemeRed">*</span></Form.Label><br />
                                        <AsyncSelect
                                            cacheOptions
                                            defaultOptions
                                            value={groupValueTrail}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchGroupPicklist(search, '')}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleGroupValue}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            }
                        </Row>&nbsp;
                        <Row>
                            <Col>
                                <Form.Check
                                    label="Account with zero balance"
                                    type="checkbox"
                                    checked={checkItem}
                                    onChange={(e) => checkBoxHandler(e)}
                                />
                            </Col>
                        </Row>&nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}
                                >Generate</Button>
                            </Col>
                        </Row>
                    </> : null}
                {scr === "V" ? <>
                    <Row>
                        <Col>
                            <Button onClick={() => setScr('')} variant="primary">Back</Button>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    &nbsp;
                    <Table responsive striped bordered>
                        <thead>

                            <tr>
                                <th>Group</th>
                                <th>Group Name</th>
                                <th>Opn Dr</th>
                                <th>Opn Cr</th>
                                <th>Per Dr</th>
                                <th>Per Cr</th>
                                {/* <th>Cls Dr</th>
                                <th>Cls Cr</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                trialList.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{item.mvg_srno}</td>           {/* Group */}
                                            <td>{item.mvg_group_name}</td>     {/* Group Name */}
                                            <td>{item.total_opn}</td>          {/* Opn Dr */}
                                            <td>{item.total_opn}</td>          {/* Opn Cr */}
                                            <td>{item.Total_Amount}</td>       {/* Per Dr */}
                                            <td>{item.Total_Amount}</td>       {/* Per Cr */}
                                            {/* <td>{item.tcbb_out_srno}</td>       Out Srno */}
                                            {/* <td>{item.tcbb_out_type}</td>       Out Type */}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </Table>

                </> : null}
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>


            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div>
    )
}

export default Trial_balance
